<script>
  import { _ as t } from "svelte-i18n";
  import { gql } from "@apollo/client/core";
  import { query } from "svelte-apollo";

  import { client } from "apollo.js";

  import { Aside, Button, Title, VerticalNav } from "t2c-components";
  import { theme, sidebarCollapsed } from "stores.js";
  import { setLanguage, getLanguage } from "i18n/language.js";

  const ORGANIZATION_INFO_QUERY = gql`
    query ClientInfoQuery {
      organizationConfig {
        id
        name
        logoHash
        theme
      }
      meClient {
        id
        name
      }
    }
  `;

  $: ENactive = $getLanguage === "en";
  $: ITactive = $getLanguage === "it";

  const setLang = (lang) => {
    setLanguage(lang);
  };

  $: nightTheme = $theme === "dark";

  const organizationDetail = query(client, {
    query: ORGANIZATION_INFO_QUERY,
  });

  const nav = [
    { to: "/", icon: "home", label: $t("dashboard") },
    { to: "/personal", icon: "client", label: $t("personalData") },
    { to: "/activities", icon: "activity", label: $t("activityLogs") },
    { to: "/settings", icon: "settings", label: $t("settings") },
  ];
</script>

<Aside {nightTheme} {sidebarCollapsed}>
  <div
    class="content"
    on:click={(e) => {
      e.stopPropagation();
      sidebarCollapsed.update((s) => !s);
    }}
  >
    {#await $organizationDetail then result}
      <div class={`logo ${$sidebarCollapsed ? "small" : ""}`}>
        {#if result.data.organizationConfig.logoHash}
          <img
            src={`/download-file/logo/${result.data.organizationConfig.id}?hash=${result.data.organizationConfig.logoHash}`}
            alt="logo"
          />
        {/if}
      </div>
    {/await}
    <Title
      style={nightTheme ? "reverse" : ""}
      vertical={$sidebarCollapsed}
      title={$t("mylawyer")}
    />
    <div class="section" class:collapsed={$sidebarCollapsed} class:nightTheme>
      <h3 class="lawyer">
        {#await $organizationDetail then result}
          {result.data.organizationConfig
            ? result.data.organizationConfig.name
            : ""}
        {/await}
      </h3>
    </div>
    <div class="section" class:collapsed={$sidebarCollapsed} class:nightTheme>
      <VerticalNav links={nav} />
    </div>
  </div>
  <div class="footer" class:collapsed={$sidebarCollapsed}>
    <div class="languages">
      <p class={ENactive ? "active" : ""} on:click={() => setLang("en")}>EN</p>
      <p class={ITactive ? "active" : ""} on:click={() => setLang("it")}>IT</p>
    </div>
    <Button style={nightTheme ? "inverted" : ""} text={$t("logout")} on:click />
    <p>
      2021 &copy; Time2Client
      <a href="https://www.iubenda.com/termini-e-condizioni/64039599">Term</a>
      /
      <a href="https://www.iubenda.com/privacy-policy/64039599">
        Privacy Policy
      </a>
      /
      <a href="https://www.iubenda.com/privacy-policy/64039599/cookie-policy">
        Cookie Policy
      </a>
      /
      <a href="https://time2client.com/contacts">Contacts</a>
    </p>
  </div>
</Aside>

<style>
  .section {
    transition: all ease-in-out 0.5s;
    transform: translateX(0px);
  }

  .section:not(.nightTheme) {
    border-bottom: 1px solid var(--night);
  }

  .section.nightTheme {
    border-bottom: 1px solid white;
  }

  .section.collapsed {
    transform: translateX(-200px);
  }
  .lawyer {
    margin: 0;
    padding: 18px 0;
    font-size: 26px;
    font-weight: 300;
  }

  .logo {
    width: 150px;
    margin-bottom: 32px;
    transition: all 0.5s ease-in-out;
  }

  .logo.small {
    width: 60px;
    margin-left: -30px;
  }

  .logo img {
    width: 100%;
  }

  .content {
    padding: 24px 0;
    cursor: pointer;
  }

  .footer {
    padding-bottom: 12px;
  }

  .footer p {
    margin: 24px 0;
    font-size: 12px;
    font-family: "IBM Plex Sans", sans-serif;
  }

  .languages {
    display: flex;
  }

  .languages p {
    padding-right: 10px;
    color: var(--marine-color);
    cursor: pointer;
  }

  .languages p.active {
    color: var(--accent-color);
  }

  .footer {
    transition: all ease-in-out 0.5s;
    transform: translateX(0px);
  }

  .footer.collapsed {
    transform: translateX(-300px);
  }
</style>
